export interface InterfaceLanguage {
  code: string;
  label: string;
  shortLabel: string;
}

export const supportedLanguages = [
  { code: 'zh-CN', label: '简体中文', shortLabel: '简' },
  { code: 'zh-TW', label: '繁體中文', shortLabel: '繁' },
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'ja', label: '日本語', shortLabel: '日' },
  { code: 'ko', label: '한국어', shortLabel: '한' },
  { code: 'th', label: 'ไทย', shortLabel: 'TH' },
  { code: 'vi', label: 'Tiếng Việt', shortLabel: 'VI' },
  { code: 'id', label: 'Bahasa Indonesia', shortLabel: 'ID' },
  { code: 'ms', label: 'Bahasa Melayu', shortLabel: 'MS' },
] as const satisfies readonly InterfaceLanguage[];

export function normalizeInterfaceLanguage(value?: string) {
  const raw = String(value || '').replace('_', '-');
  const exact = supportedLanguages.find((item) => item.code.toLowerCase() === raw.toLowerCase());
  if (exact) return exact.code;
  const base = raw.split('-')[0].toLowerCase();
  return supportedLanguages.find((item) => item.code.split('-')[0].toLowerCase() === base)?.code || 'zh-CN';
}
